import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';

import rootReducer from './reducers';

const basename = process.env.NODE_ENV === 'development' ? '/' : '/grb/app';

export const history = createBrowserHistory({ basename });

// Initialize store
let store;

// Return a function so we can configure it
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
	if (store) {
		return store;
	}

	const initialState = {};
	const enhancers = [];
	const middleware = [thunk, routerMiddleware(history)];

	// if (['local', 'testing', 'testing2'].indexOf(process.env.NODE_ENV) !== -1) {
	// 	const devToolsExtension = window.devToolsExtension;

	// 	if (typeof devToolsExtension === 'function') {
	// 		enhancers.push(devToolsExtension());
	// 	}
	// }

	// enhancers
	const composedEnhancers = compose(
		applyMiddleware(...middleware),
		// devtools redux
		(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'testing2')
			&& window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
			window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__() : compose(),
		...enhancers
	);

	// create store
	store = createStore(rootReducer(history), initialState, composedEnhancers);

	return store;
};
